// PR-1 — the one switch the client's Drawings tab reads: client_visible.
export const ClientVisibleSwitch = ({ drawing, onToggle }) => (
  <button
    type="button"
    className="kdc-client-switch"
    aria-pressed={!!drawing.client_visible}
    data-testid={`drawing-client-visible-${drawing.id}`}
    onClick={(e) => { e.stopPropagation(); onToggle(drawing); }}
  >
    {drawing.client_visible ? 'Shown to client · Hide' : 'Show to client'}
  </button>
);

// PR-1 — whether the client can see the Drawings tab at all.
export const portalDrawingsNote = (desk) => {
  if (!desk || !desk.access) return 'No client portal yet';
  if (desk.tabs && desk.tabs.drawings === false) {
    return "The client's Drawings tab is off — turn it on at Project Desk → Client portal when the set is ready.";
  }
  return null;
};
